const Vue = require('vue')
const Sortable = require('sortablejs')

Vue.component('ui-new-sortable', {
    props: {
        model: {
            twoWay: true,
            required: true
        },
        onSorted: {
            type: Function
        }
    },
    template: `<div v-el:holder><slot></slot></div>`,
    ready () {
        Vue.nextTick(() => this.bind())
    },
    methods: {
        bind () {
            const self = this
            const el = self.$els.holder

            Sortable.create(el, {
                draggable: '.sortable-item',
                onEnd: function () {
                    let comment = el.firstChild
                    do {
                        if (comment.nodeType === 8) {
                            el.removeChild(comment)
                            el.appendChild(comment)
                        }
                    } while (comment = comment.nextSibling)
                },
                onUpdate: function (e) {
                    const rawOldPosition = e.item.getAttribute('data-id')

                    const oldPosition = parseInt(rawOldPosition)

                    const newPosition = this.toArray().indexOf(rawOldPosition)

                    self.model.splice(newPosition, 0, self.model.splice(oldPosition, 1)[0])

                    if (self.onSorted) {
                        self.onSorted()
                    }
                }
            })
        }
    }
})

Vue.directive('ui-sortable', {
    twoWay: true,
    params: ['data', 'onSorted'],
    bind: function () {
        const self = this
        const list = self.params.data
        const el = self.el

        Sortable.create(el, {
            draggable: '.sortable-item',
            onEnd: function () {
                let comment = el.firstChild
                do {
                    if (comment.nodeType === 8) {
                        el.removeChild(comment)
                        el.appendChild(comment)
                    }
                } while (comment = comment.nextSibling)
            },
            onUpdate: function (e) {
                const oldPosition = e.item.getAttribute('data-id')

                const newPosition = this.toArray().indexOf(oldPosition)

                list.splice(newPosition, 0, list.splice(oldPosition, 1)[0])

                if (self.params.onSorted) {
                    self.params.onSorted()
                }
            }
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui-sortable.js